function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import c from 'classnames';
const Icon = _ref => {
  let {
    icon,
    variant = 'primary',
    className,
    ...props
  } = _ref;
  const classNames = c(className, 'icon', "icon-".concat(icon), "icon-variant-".concat(variant));
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classNames
  }));
};
export default Icon;